// removed by extract-text-webpack-plugin
module.exports = {"NotificationHolder":"NotificationHolder__NotificationHolder__3b8r6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/NotificationHolder/NotificationHolder.css
// module id = 308
// module chunks = 0